var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotMode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "b",
    width: 1608,
    height: 612,
    x: 282,
    y: 141,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "100.1%",
    height: "100.7%",
    x: "-.1%",
    y: "-.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "Sourcefade",
    radius: 2.5,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "Sourcefade",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.704031571 0 0 0 0 0.685494773 0 0 0 0 0.796715561 0 0 0 0.633604677 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ECEBEF",
    d: "M-724-351h1920V729H-724z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-724 -351)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1607,
    height: 611,
    x: 282.5,
    y: 141.5,
    fill: "#FEFEFE",
    stroke: "#EBEBEB",
    strokeLinejoin: "square",
    rx: 4
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#D5D2D5",
    d: "M-426.5-126.5V381a3.5 3.5 0 0 0 3.5 3.5h1570a3.5 3.5 0 0 0 3.5-3.5v-507.5h-1577z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#D5D2D5",
    d: "M213.5 33v-137a3.5 3.5 0 0 0-3.5-3.5H-57a3.5 3.5 0 0 0-3.5 3.5V33a3.5 3.5 0 0 0 3.5 3.5h267a3.5 3.5 0 0 0 3.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D5D2D5",
    d: "M-6.5-7.5v34h22c9.389 0 17-7.611 17-17s-7.611-17-17-17h-22z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#F05146",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.775,
    d: "M14.707 9.97a4.737 4.737 0 1 1-9.475 0 4.737 4.737 0 0 1 9.475 0z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.944,
    d: "M9.97 19.444v-2.506M9.97 3.003V.497M14.707 18.227l-1.276-2.208M6.462 3.949L5.234 1.82M15.98 13.493h.002l2.193 1.268M3.913 6.526l-2.147-1.24M19.444 10.024h-2.508M3.004 10.023H.497M18.175 5.286l-2.147 1.24M1.766 14.76l2.192-1.267h.001M14.707 1.82l-1.229 2.128M6.509 16.019l-1.275 2.208"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotMode);
export default __webpack_public_path__ + "static/media/hotMode.1c58757a26760a3cd7018ec14be2d4a4.svg";
export { ForwardRef as ReactComponent };